import React, { FC } from "react";
import Const from "../../const.json";

const NoData: FC = () => {
  return (
    <div>
      <div className="custom-nodata m-5">
        {Const.noData}
      </div>
    </div>
  );
};

export default NoData;
